import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getCat } from "../../../service/api/object/getCat";
import { numberValidation } from "../../../functions/validations";
import { saveExpertise } from "../../../service/api/professional/saveExpertise";
import { getWorkInformation } from "../../../service/api/professional/getWorkInformation";
import { uploadDocumentApi } from "../../../service/api/professional/uploadDocument";
import { getDocuments } from "../../../service/api/professional/getDocuments";
import { Modal, OverlayTrigger, Popover, Spinner } from 'react-bootstrap';
import { getStateByCountryId } from "../../../service/api/countryCode/getStateByCountryId";
import deleteDocumentById from "../../../service/api/professional/deleteDocumentById";
import SkeletonDivElement from '../../../component/skeletonTableRow/skeletonDivElement';
import PrimaryButton from '../../../jsx/components/button/primaryButton';
import SelectInputCompetency from "../../../jsx/components/fields/selectInputCompetency";
import { txtExpertiseCompetency, txtMessage, validTotalWorkExp } from "../../../dataBaseFile/label";
import InputField from '../../../jsx/components/fields/inputField';

import proLicense from '../../../media/images/proDashboardAssets/proLicense.png'
import proCerificate from '../../../media/images/proDashboardAssets/proCerificate.png'
import proInsurance from '../../../media/images/proDashboardAssets/proInsurance.png'

import videoImg from '../../../media/images/proDashboardAssets/videoImg.png'

import SelectInputCountry from "../../../jsx/components/fields/selectInputCountry";
import SelectInputState from "../../../jsx/components/fields/selectInputState";
import ResponceToaster from '../../../jsx/components/responceToaster/responceToaster';
import TextArea from '../../../jsx/components/fields/textArea';
import { setIsSignUpFlagFalse, setProOnboardingFlag, setUserDetails } from '../../../feature/userData/userData';
import updateServiceRequestoptionApi from '../../../service/api/user/updateServiceRequestoption';
import { userById } from '../../../service/api/user/userById';
import { set } from 'date-fns';



const NewProDashboard = () => {
    // New dashboard for the pro account ------------------
    const { countryCodeArr } = useSelector((state) => state.country);
    const { serviceRequestOptions, isSignUpFlag, activeSubscriptionEndTime, isFreeTrialSubscription } = useSelector((state) => state.user);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const [newProDashboardSteps, setNewProDashboardSteps] = useState(1);
    const [isExpertiseErr, setIsExpertiseErr] = useState(false);
    const [catLoading, setCatLoading] = useState(false);

    const handleNewProDashboardSteps = (value) => {
        setNewProDashboardSteps(value);
    };

    // Get the categories
    const [pageSizeCat, setPageSizeCat] = useState(25);
    const [pageCat, setPageCat] = useState(1);
    const [catOrder, setCatOrder] = useState("ASC")
    const [catArr, setCatArr] = useState([]);

    const getCategoriesData = () => {
        setCatLoading(true);
        var forCatData = {
            page_index: pageCat,
            page_size: pageSizeCat,
            sorting_order: catOrder
        };

        dispatch(
            getCat(forCatData, (res) => {
                setCatLoading(false);
                setCatArr(res.data.data)
            }, (res) => {
                setCatLoading(false);
            })
        )
    }

    useEffect(() => {
        getCategoriesData();
    }, [pageCat, pageSizeCat, catOrder])

    const [selectedItems, setSelectedItems] = useState([]);

    // console.log(selectedItems, 'selectedItems')

    const handleSelectItem = (selectedItem) => {
        setIsExpertiseErr(false);
        setSelectedItems((prevSelectedItems) => {
            if (prevSelectedItems.some(item => item.category_id_ids === selectedItem.category_id_ids)) {
                // If item is already selected, remove it
                return prevSelectedItems.filter((item) => item.category_id_ids !== selectedItem.category_id_ids);
            } else {
                // If item is not selected, add it
                return [...prevSelectedItems, selectedItem];
            }
        });
    };

    const handleSelectedExpertise = () => {
        if (selectedItems.length > 0) {
            setIsExpertiseErr(false);
            handleNewProDashboardSteps(2);
        } else {
            setIsExpertiseErr(true);
            if (newProDashboardSteps !== 1) {
                setHandleToasterNew(true);
                setTimeout(() => {
                    setHandleToasterNew(false);
                }, 4000)
            }
        };
    }

    const [expertiseCompetencyArr, setExpertiseCompetencyArr] = useState([]);
    const [saveExpertiseCompetency, setSaveExpertiseCompetency] = useState('');
    const [isExpertiesCompetencyError, setIsExpertiesCompetencyError] = useState(false);
    const [isExpertiesExpError, setIsExpertiesExpError] = useState(false);
    const [saveExpertiseExp, setSaveExpertiseExp] = useState('');
    const [saveExpertiseCertificate, setSaveExpertiseCertificate] = useState(0);
    const [saveExpertiseLoading, setSaveExpertiseLoading] = useState(false);
    const [bioText, setBioText] = useState('');

    const [responceMsg, setResponceMsg] = useState("");
    const [toasterType, setToasterType] = useState('');
    const [handleToaster, setHandleToaster] = useState(false);
    const [handleToasterNew, setHandleToasterNew] = useState(false);

    // console.log(saveExpertiseCertificate, 'saveExpertiseCertificate')

    const [proOnboardingModalTrigger, setProOnboardingModalTrigger] = useState(true);
    const [subscriptionTimeLeft, setSubscriptionTimeLeft] = useState(0);

    const handleBioText = (e) => {
        setBioText(e.target.value);
    }

    const saveExpertiseCompetencyFn = (e) => {
        setSaveExpertiseCompetency(e.target.value);
        setIsExpertiesCompetencyError(false);
    }

    const saveExpertiseExpFn = (e) => {
        setIsExpertiesExpError(false)
        setSaveExpertiseExp(e.target.value.replace(/\D/g, ''));
    }

    const handleSaveExpertiseExpBlurCheck = () => {
        if (isNaN(saveExpertiseExp) || saveExpertiseExp === '' || (saveExpertiseExp > 99)) {
            setIsExpertiesExpError(true);
        }
    }



    const [individualExpertiseObj, setIndividualExpertiseObj] = useState({});
    const [individualExpertiseCounter, setIndividualExpertiseCounter] = useState(0);

    useEffect(() => {
        if (selectedItems.length > 0 && individualExpertiseCounter === 0) {
            setIndividualExpertiseObj(selectedItems[0])
        }
    }, [selectedItems])


    const handleSaveExpertise = () => {

        if (individualExpertiseCounter < selectedItems.length) {

            setSaveExpertiseLoading(true);
            if (isNaN(saveExpertiseExp) || saveExpertiseExp === '' || (saveExpertiseExp > 99)) {
                setIsExpertiesExpError(true);
                setSaveExpertiseLoading(false);
            }
            if (saveExpertiseCompetency == "" || !saveExpertiseCompetency) {
                setSaveExpertiseLoading(false);
                setIsExpertiesCompetencyError(true);
            }

            if (isNaN(saveExpertiseExp) || (saveExpertiseExp === '') || (saveExpertiseExp > 99)
                || (saveExpertiseCompetency == "") || !saveExpertiseCompetency) {
                setSaveExpertiseLoading(false);
                // setIsExpertiesCertificationError(true);
                return;
            }

            if (!isExpertiesExpError && !isExpertiesCompetencyError) {

                const details = {
                    user_id_ids: localStorage.getItem('user_id'),
                    expertise_id_ids: "",
                    expertise_name_chr: individualExpertiseObj?.category_name_chr,
                    expertise_competency_int: parseInt(saveExpertiseCompetency),
                    work_experience_int: parseInt(saveExpertiseExp),
                    is_certified_ysn: saveExpertiseCertificate ? 1 : 0,
                    bio_chr: bioText,
                    product_type_experties_info: [],
                }


                if (numberValidation(saveExpertiseExp)) {
                    dispatch(
                        saveExpertise(
                            details,
                            (res) => {
                                setResponceMsg(res.data.message);
                                // console.log(res.data.message);
                                setToasterType("success")

                                clearExpertiseState();
                                setSaveExpertiseCompetency('')

                                // if (individualExpertiseCounter < selectedItems.length - 1) {
                                // 	setIndividualExpertiseCounter(individualExpertiseCounter + 1)
                                // }

                                setIndividualExpertiseCounter(individualExpertiseCounter + 1)

                                setSaveExpertiseLoading(false);

                                if (individualExpertiseCounter == (selectedItems.length - 1)) {
                                    handleNewProDashboardSteps(3)
                                    setSelectedItems([])
                                    setIndividualExpertiseCounter(0)
                                    setIndividualExpertiseObj({})
                                }

                                // setHandleToaster(true);
                                // setTimeout(() => {
                                //     // clearExpertiseState();
                                //     setHandleToaster(false);
                                // }, 11000);

                            },
                            (res) => {
                                setResponceMsg(res.data.message);
                                setToasterType("error")
                                // console.log(res.data.message);

                                setSaveExpertiseLoading(false);

                                setIndividualExpertiseCounter(individualExpertiseCounter + 1)

                                if (individualExpertiseCounter == (selectedItems.length - 1)) {
                                    handleNewProDashboardSteps(3)
                                    setSelectedItems([])
                                    setIndividualExpertiseCounter(0)
                                    setIndividualExpertiseObj({})
                                }

                                clearExpertiseState();
                                setHandleToaster(true);
                                setTimeout(() => {
                                    setHandleToaster(false);
                                }, 16000);
                            },
                        )
                    )
                }
            }
        }
    }

    function clearExpertiseState() {
        setSaveExpertiseCompetency('')
        setSaveExpertiseExp('')
        setBioText('')
        setSaveExpertiseCertificate(0)
        setIsExpertiesExpError(false);
        setIsExpertiesCompetencyError(false);
    }

    // console.log(saveExpertiseCompetency, 'saveExpertiseCompetency-------')


    useEffect(() => {
        if (individualExpertiseCounter > 0 && individualExpertiseCounter < selectedItems.length) {
            setIndividualExpertiseObj(selectedItems[individualExpertiseCounter])
        }
    }, [individualExpertiseCounter])

    // console.log(individualExpertiseObj, 'individualExpertiseObj')

    const getWorkInfoFn = () => {
        let details = {
            user_id_ids: localStorage.getItem('user_id'),
        }

        dispatch(
            getWorkInformation(details, (res) => {
                // console.log(res, "user work Data comes here")
                setExpertiseCompetencyArr(res?.data?.expertise_competency_list)
            }),
            (res) => { }
        )
    }

    useEffect(() => {
        if (newProDashboardSteps == 1) {
            getWorkInfoFn();
        }
    }, [newProDashboardSteps])

    // Pro upload documents functions -------
    // Upload the professional documents new functions
    const [documentsModalTrigger, setDocumentsModalTrigger] = useState(false);
    const [updateDocumentsLoading, setUpdateDocumentsLoading] = useState(false);
    const [toggleForDocuments, setToggleForDocuments] = useState(1);
    const [documentTypeInt, setDocumentTypeInt] = useState();
    const [documentTypeName, setDocumentTypeName] = useState('');
    const [documentId, setDocumentId] = useState('');
    const [documentCountryName, setDocumentCountryName] = useState('');
    const [documentCountryId, setDocumentCountryId] = useState('');
    const [isDocumentErr, setIsDocumentErr] = useState(false);
    const [documentStateName, setDocumentStateName] = useState('');
    const [documentStateId, setDocumentStateId] = useState('');
    const [uploadDoc, setUploadDoc] = useState(null);
    const [uploadDocImgPre, setUploadDocImgPre] = useState();
    const [documentNotes, setDocumentNotes] = useState('');

    const [proDocumentsArr, setProDocumentsArr] = useState([])

    const documentTypesArr = [
        { id: 1, name: 'License', description: 'Helps to verify your expertise' },
        { id: 2, name: 'Certificate', description: 'Helps to verify your expertise' },
        { id: 3, name: 'Address', description: 'Helps to verify your identity' },
        { id: 4, name: 'Insurance', description: 'Helps to verify your identity' },
    ]

    const handleCloseDocumentsModal = () => {
        setDocumentsModalTrigger(false);
        handleClearDocStates();
    }

    const handleDocumentCountryName = (e) => {
        setDocumentCountryName(e.target.value);
    }

    const handleDocumentStateName = (e) => {
        setDocumentStateName(e.target.value);
    }

    useEffect(() => {
        if (documentCountryName !== "") {
            countryCodeArr?.map((item) => {
                if (item.country_name_chr === documentCountryName) {
                    setDocumentCountryId(item.country_id_ids);
                }
            })
        }
    }, [documentCountryName]);

    useEffect(() => {
        if (documentStateName !== "") {
            stateArr?.map((item) => {
                if (item.state_name_chr === documentStateName) {
                    setDocumentStateId(item.state_id_ids);
                }
            })
        }
    }, [documentStateName]);

    // console.log("documentCountryName->", documentCountryName, " documentCountryId-> ", documentCountryId)
    // console.log("documentStateName->", documentStateName, " documentStateId-> ", documentStateId)


    // Upload document ->

    const [pdfFile, setPdfFile] = useState(null);
    const [numPages, setNumPages] = useState(null);

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    const uploadDocRef = useRef();
    const handleClickUploadDoc = () => {
        uploadDocRef.current.click();
        setStateApiFlag(true);
    }

    const handleUploadDoc = (e) => {
        // old code
        if (e.target.files) {
            setUploadDoc(e.target.files[0]);
            setUploadDocImgPre(URL.createObjectURL(e.target.files[0]));
            setIsDocumentErr(false);
            e.target.value = null;
        }

        // if (e.target.files) {
        //     const file = e.target.files[0];
        //     const fileType = file.type;

        //     if (fileType.startsWith('image/')) {
        //         setUploadDoc(file);
        //         setUploadDocImgPre(URL.createObjectURL(file));
        //         setPdfFile(null); // Reset PDF preview
        //     } else if (fileType === 'application/pdf') {
        //         setUploadDoc(file);
        //         setUploadDocImgPre(null); // Reset image preview
        //         setPdfFile(URL.createObjectURL(file));
        //     }
        //     setIsDocumentErr(false);
        //     e.target.value = null; // Clear the input value to allow re-upload of the same file
        // }
    }

    const deleteUploadDoc = () => {
        setUploadDoc(null);
        setUploadDocImgPre(null);
        setFileSizeLimitErr(false);
    }

    const handleOpenDocumentsModal = () => {
        setDocumentsModalTrigger(true);
        setStateApiFlag(true);

        setShowPopover1(false);
        setShowPopover2(false);
        setShowPopover3(false);
        setShowPopover4(false);
        setShowPopover5(false);
        setShowPopover6(false);
    }

    const handleDocTypeSelected = (element) => {
        setDocumentTypeInt(element.id);
        setDocumentTypeName(element.name);
        setToggleForDocuments(2);
    }

    const handleClearDocStates = () => {
        setToggleForDocuments(2);
        setDocumentTypeInt();
        setDocumentTypeName(``);
        setDocumentId(``);
        deleteUploadDoc();
        setDocumentCountryName(``);
        setDocumentCountryId(``);
        setDocumentStateName(``);
        setDocumentStateId(``);
        setIsDocumentErr(false);
        setDocumentObject({});
        setDocumentNotes(``);
        setFileSizeLimitErr(false);
    }

    const handleDocumentNotes = (e) => {
        setDocumentNotes(e.target.value);
    }

    const [fileSizeLimitErr, setFileSizeLimitErr] = useState(false);
    const uploadProfessionalDocumentFn = () => {

        if (uploadDoc) {
            if (uploadDoc.size < 20 * 1024 * 1024) {
                setUpdateDocumentsLoading(true);

                let details = new FormData();

                details.append("user_id_ids", localStorage.getItem('user_id'));

                details.append("document_type_int", documentTypeInt);
                details.append("document_id_ids", documentId);
                details.append("document_file", uploadDoc);
                documentCountryId && details.append("country_id_ids", documentCountryId);
                documentCountryName && details.append("country_name_chr", documentCountryName);
                documentStateId && details.append("state_id_ids", documentStateId);
                documentStateName && details.append("state_name_chr", documentStateName);
                documentNotes && details.append("note_chr", documentNotes);

                dispatch(
                    uploadDocumentApi(details,
                        (res) => {
                            setResponceMsg(res.data.message)
                            setToasterType("success")
                            let details = {
                                user_id_ids: localStorage.getItem('user_id'),
                            }

                            getProDocumentsFn();

                            handleCloseDocumentsModal();
                            setUpdateDocumentsLoading(false);

                            handleClearDocStates();

                            // setHandleToaster(true);
                            // setTimeout(() => {
                            //     setHandleToaster(false);
                            // }, 11000);
                        },
                        (res) => {
                            setResponceMsg(res.data.message)
                            setToasterType("error")
                            setUpdateDocumentsLoading(false);

                            setHandleToaster(true);
                            setTimeout(() => {
                                setHandleToaster(false);
                            }, 16000);
                        })
                )
            } else {
                setFileSizeLimitErr(true);
            }
        } else {
            setIsDocumentErr(true);
        }
    }

    const popoverDocument = (index) => (
        <Popover
            // id="popover-basic"
            id={`popover-basic-${index}`}

            //   className="custom-popover"
            style={{ minWidth: "100px", border: 'none' }}
        >
            <Popover.Body
                className="p-2 popover-body"
                style={{
                    //   padding: "5px",
                    boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.2)",

                }}
            >
                <div className="d-flex flex-column font-w500 fs-6" style={{}}>
                    <div
                        onClick={(e) => {
                            editDocument(e, documentObject);
                            setActivePopover(null)
                        }}
                        className='border-bottom cursor-pointer p-2  text-black overlay-action-btn'
                    >
                        <span className='me-2'>
                            <i className="bi bi-pencil"></i>
                        </span>
                        <span>Edit</span>
                    </div>
                    <div
                        onClick={(e) => {
                            handleOpenDeleteDocumentModal()
                            setActivePopover(null)
                        }}
                        className=' cursor-pointer p-2 text-danger overlay-action-btn'
                    >
                        <span className='me-2'>
                            <i className="bi bi-trash"></i>
                        </span>
                        <span>Delete</span>
                    </div>
                </div>
            </Popover.Body>
        </Popover>
    );

    const [activePopover, setActivePopover] = useState(null);
    const [documentObject, setDocumentObject] = useState({});
    const editDocument = (e, documentObject) => {
        e.stopPropagation();

        setToggleForDocuments(2);

        setDocumentId(documentObject.document_id_ids);
        setDocumentTypeInt(documentObject.document_type_int);
        documentObject.country_name_chr && setDocumentCountryName(documentObject.country_name_chr);
        documentObject.country_id_lng && setDocumentCountryId(documentObject.country_id_lng);
        documentObject.state_name_chr && setDocumentStateName(documentObject.state_name_chr);
        documentObject.state_id_lng && setDocumentStateId(documentObject.state_id_lng);
        documentObject.note_chr && setDocumentNotes(documentObject.note_chr);

        setDocumentTypeName(
            documentObject?.document_type_int == 1 ? "Identity" :
                documentObject?.document_type_int == 2 ? "Certificate" :
                    documentObject?.document_type_int == 3 ? "Address" :
                        documentObject?.document_type_int == 4 ? "Insurance" : "Other"
        )

        handleOpenDocumentsModal();
    }

    const handleMenuClick = (element, index) => {
        setDocumentObject(element)
        setActivePopover(activePopover === index ? null : index)
    }

    // images previewer for the documents

    const [documentType, setDocumentType] = useState();
    const [imageAttachURL, setImageAttachURL] = useState('');
    const [openDoc, setOpenDoc] = React.useState(false);
    const handleOpenDoc = (docType) => {
        setDocumentType(docType);
        setOpenDoc(true);
    }
    const handleCloseDoc = () => setOpenDoc(false);

    // Get the country for document 
    // const [countryArr, setCountryArr] = useState([]);
    const [stateArr, setStateArr] = useState([]);
    const [getStateApiFlag, setStateApiFlag] = useState(false);
    const getStatesData = () => {
        let data = {
            country_id_ids: 1
        }
        dispatch(
            getStateByCountryId(data,
                (res) => {
                    setStateArr(res.data)
                    // console.log(res, "here is ----------------------");
                })
        )
    }

    // useEffect(() => {
    //     if (getStateApiFlag) {
    //         getStatesData();
    //     }
    // }, [getStateApiFlag]);

    // Functions for deleting particular document
    const [showPopover1, setShowPopover1] = useState(false);
    const [showPopover2, setShowPopover2] = useState(false);
    const [showPopover3, setShowPopover3] = useState(false);
    const [showPopover4, setShowPopover4] = useState(false);
    const [showPopover5, setShowPopover5] = useState(false);
    const [showPopover6, setShowPopover6] = useState(false);
    const [deleteDocumentModalTrigger, setDeleteDocumentModalTrigger] = useState(false);

    const [deleteDocumentType, setDeleteDocumentType] = useState(1);
    const [deleteDocumentId, setDeleteDocumentId] = useState('');

    const handleOpenDeleteDocumentModal = () => {
        setDeleteDocumentModalTrigger(true);

        setShowPopover1(false);
        setShowPopover2(false);
        setShowPopover3(false);
        setShowPopover4(false);
        setShowPopover5(false);
        setShowPopover6(false);
    }

    const handleCloseDeleteDocumentModal = () => {
        setDeleteDocumentModalTrigger(false);
        handleClearDocStates();
    }



    function delelteDocumentByIdFn() {
        setUpdateDocumentsLoading(true);
        // let details = {
        //     document_id_ids: deleteDocumentId,
        //     document_type: parseInt(deleteDocumentType),
        // };

        let details = {
            document_id_ids: documentObject.document_id_ids,
            document_type: parseInt(documentObject.document_type_int),
        };


        dispatch(
            deleteDocumentById(details,
                (res) => {
                    setResponceMsg(res.data.message)
                    setToasterType("success")
                    let details = {
                        user_id_ids: localStorage.getItem('user_id'),
                    }

                    getProDocumentsFn();
                    handleCloseDeleteDocumentModal();

                    setDocumentsModalTrigger(false);
                    setUpdateDocumentsLoading(false);
                    // clearDocumentFn();

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                },
                (res) => {

                    setResponceMsg(res.data.message)
                    setToasterType("error")
                    setUpdateDocumentsLoading(false);
                    // clearDocumentFn();
                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 16000);
                })
        )
    }

    // Get the documents for the professionals
    const getProDocumentsFn = () => {
        let details = {
            user_id_ids: localStorage.getItem('user_id'),
        }
        dispatch(
            getDocuments(details,
                (res) => {
                    // console.log(res)
                    setProDocumentsArr(res?.data?.data?.pro_documents)
                },
                (res) => {
                }
            )
        )
    }


    // Image loading effect
    const [isLoadingImg, setIsLoadingImg] = useState(true);

    const handleImageLoaded = () => {
        setIsLoadingImg(false);
    };

    const handleImageError = () => {
        console.error('Failed to load the image.');
        setIsLoadingImg(false);
    };


    useEffect(() => {
        return () => {
            dispatch(setProOnboardingFlag())
            dispatch(setIsSignUpFlagFalse())
        }
    }, [])


    const [useChilllModalTrigger, setUseChilllModalTrigger] = useState(false);
    const [serviceReqOptionId, setServiceReqOptionId] = useState(1);
    const [serviceReqOptionErr, setServiceReqOptionErr] = useState(false);
    const [serviceReqOptionLoading, setServiceReqOptionLoading] = useState(false);

    const handleOpenUseChilllModal = () => {
        // setUseChilllModalTrigger(true);
    }

    const handleCloseUseChilllModal = () => {
        setUseChilllModalTrigger(false);
    }

    const handleServiceRequestoption = (ele) => {
        setServiceReqOptionId(ele.option_id_ids);
        setServiceReqOptionErr(false);
    }

    function handleGetUserById(e) {
        let details = {
            user_id_ids: localStorage.getItem("user_id"),
            role_id_int: localStorage.getItem("roleId"),
            user_impersonate_flag: 0,
        };

        dispatch(
            userById(
                details,
                (res) => {
                    dispatch(setUserDetails(res.data.data));
                    localStorage.setItem("triggerFlag", res.data.data.is_available_ysn);
                },
                (err) => { }
            )
        );
    }


    const handleSubmitServiceReqOption = () => {
        if (serviceReqOptionId) {
            setServiceReqOptionLoading(true);
            let data = new FormData();
            data.append('user_id_ids', localStorage.getItem('user_id'));
            data.append('service_request_flag', serviceReqOptionId);

            dispatch(
                updateServiceRequestoptionApi(data,
                    (res) => {
                        setServiceReqOptionLoading(false);
                        setResponceMsg(res.data.message)
                        // setToasterType("success")
                        handleCloseUseChilllModal();
                        handleGetUserById();

                        if (serviceReqOptionId === 1) {
                            dispatch(setProOnboardingFlag())
                        }


                        // setHandleToaster(true);
                        // setTimeout(() => {
                        //     setHandleToaster(false);
                        // }, 5000);
                    },
                    (res) => {
                        setServiceReqOptionLoading(false);
                        setResponceMsg(res.data.message)
                        setToasterType("error")
                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 16000);
                    })
            )
        } else {
            setServiceReqOptionErr(true);
        }
    }

    useEffect(() => {
        console.log(isSignUpFlag, "isSignUpFlag", proOnboardingModalTrigger, "proOnboardingModalTrigger", isFreeTrialSubscription, "isFreeTrialSubscription", subscriptionTimeLeft, "subscriptionTimeLeft");
        console.log(isSignUpFlag && proOnboardingModalTrigger && isFreeTrialSubscription && subscriptionTimeLeft, 'final check');
    }, [isSignUpFlag, proOnboardingModalTrigger, isFreeTrialSubscription, subscriptionTimeLeft])

    const getSubscriptionDaysLeft = (unixEndDate) => {
        const currentDate = new Date().getTime(); // Get current date in UNIX timestamp (milliseconds)
        const subscriptionEndDate = unixEndDate * 1000; // Convert UNIX timestamp from seconds to milliseconds

        // Calculate the difference in time (milliseconds)
        const timeDiff = subscriptionEndDate - currentDate;

        // Convert time difference from milliseconds to days
        // const daysLeft = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));


        if (daysLeft >= 0) {
            setSubscriptionTimeLeft(daysLeft);
        } else {
            setSubscriptionTimeLeft(0);
        }
    }

    useEffect(() => {
        getSubscriptionDaysLeft(activeSubscriptionEndTime);
    }, [activeSubscriptionEndTime]);


    return (
        <>
            <div className="row mx-0">
                <div className="col-12 p-4 d-flex justify-content-center align-items-center">

                    <div className="row mx-0">
                        <div className="col-12 px-0">

                            <div className="row mx-0">
                                <div className="col-12 px-0 d-flex justify-content-center align-items-center my-1" >

                                    <div
                                        className={`d-flex justify-content-center align-items-center fs-3 rounded-circle font-w600 me-3 cursor-pointer text-hovered border-hovered ${newProDashboardSteps === 1 && 'shadow'}`}
                                        style={{
                                            height: '40px',
                                            width: '40px',
                                            backgroundColor: newProDashboardSteps === 1 ? 'white' : 'rgba(235, 240, 250, 1)',
                                            border: newProDashboardSteps === 1 ? '1px solid rgba(255, 116, 1, 1)' : '1px solid rgba(199, 212, 234, 1)',
                                            color: newProDashboardSteps === 1 ? 'rgba(255, 116, 1, 1)' : 'rgba(199, 212, 234, 1)',
                                        }}
                                        onClick={(e) => { handleNewProDashboardSteps(1) }}
                                    >
                                        <span>{1}</span>
                                    </div>

                                    <div
                                        className={`d-flex justify-content-center align-items-center fs-3 rounded-circle font-w600 me-3 cursor-pointer text-hovered border-hovered ${newProDashboardSteps === 2 && 'shadow'}`}
                                        style={{
                                            height: '40px',
                                            width: '40px',
                                            backgroundColor: newProDashboardSteps === 2 ? 'white' : 'rgba(235, 240, 250, 1)',
                                            border: newProDashboardSteps === 2 ? '1px solid rgba(255, 116, 1, 1)' : '1px solid rgba(199, 212, 234, 1)',
                                            color: newProDashboardSteps === 2 ? 'rgba(255, 116, 1, 1)' : 'rgba(199, 212, 234, 1)',
                                        }}
                                        onClick={() => { handleSelectedExpertise() }}
                                    >
                                        <span>{2}</span>
                                    </div>

                                    <div
                                        className={`d-flex justify-content-center align-items-center fs-4 rounded-circle font-w600 me-3 cursor-pointer text-hovered border-hovered ${newProDashboardSteps === 3 && 'shadow'}`}
                                        style={{
                                            height: '40px',
                                            width: '40px',
                                            backgroundColor: newProDashboardSteps === 3 ? 'white' : 'rgba(235, 240, 250, 1)',
                                            border: newProDashboardSteps === 3 ? '1px solid rgba(255, 116, 1, 1)' : '1px solid rgba(199, 212, 234, 1)',
                                            color: newProDashboardSteps === 3 ? 'rgba(255, 116, 1, 1)' : 'rgba(199, 212, 234, 1)',
                                        }}
                                        onClick={(e) => { handleNewProDashboardSteps(3) }}
                                    >
                                        <span>{3}</span>
                                    </div>

                                    <div
                                        className={`d-flex justify-content-center align-items-center fs-4 rounded-circle font-w600 cursor-pointer text-hovered border-hovered ${newProDashboardSteps === 4 && 'shadow'}`}
                                        style={{
                                            height: '40px',
                                            width: '40px',
                                            backgroundColor: newProDashboardSteps === 4 ? 'white' : 'rgba(235, 240, 250, 1)',
                                            border: newProDashboardSteps === 4 ? '1px solid rgba(255, 116, 1, 1)' : '1px solid rgba(199, 212, 234, 1)',
                                            color: newProDashboardSteps === 4 ? 'rgba(255, 116, 1, 1)' : 'rgba(199, 212, 234, 1)',
                                        }}
                                        onClick={(e) => { handleNewProDashboardSteps(4) }}
                                    >
                                        <span>{4}</span>
                                    </div>


                                </div>
                            </div>

                            {newProDashboardSteps === 1 ?
                                <>
                                    <div className="row mx-0">
                                        <div className="col-12 px-0">

                                            <div className="row mx-0 mt-4">
                                                <div className="col-12 px-0 d-flex justify-content-center align-items-center">
                                                    <span className="fs-2 font-w600 text-black text-center my-2">{`First, tell us about your experience`}</span>
                                                </div>
                                            </div>

                                            <div className="row mx-0 mb-2">
                                                <div className="col-12 px-0 d-flex justify-content-center align-items-center">
                                                    <span className="fs-4 text-center my-2">{`To start working on Chilll as a Pro, you need to fill out your Pro profile. Your progress will be automatically saved as you complete each step.`}</span>
                                                </div>
                                            </div>


                                            <div className="row">
                                                <div className="col-12 px-0 d-flex justify-content-center align-items-center flex-column">

                                                    <div className="row mx-0  my-3 w-100">
                                                        <div className="col-12 px-3 d-flex align-items-center p-2 border border-light rounded-3 fs-5">
                                                            <span style={{ color: 'rgb(199, 212, 234)' }}>
                                                                <i class="bi bi-info-circle"></i>
                                                            </span>
                                                            <span className="ms-2">{`Select all that apply`}</span>
                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-12 d-flex flex-wrap justify-content-center  py-3">

                                                            {catLoading ? <>
                                                                {[...Array(5)]?.map((item, index) => {
                                                                    return (
                                                                        <div className="m-2" key={index}>
                                                                            <SkeletonDivElement
                                                                                height={"170px"}
                                                                                width={"130px"}
                                                                                borderRadius={'7px'}
                                                                                marginBottom={'5px'}
                                                                            />
                                                                        </div>
                                                                    )
                                                                })}
                                                            </> : <>
                                                                {catArr?.length > 0 ? <>
                                                                    {catArr?.map((item, index) => {
                                                                        return (
                                                                            <div
                                                                                className={`shadow rounded-2 p-4 m-1 d-flex align-items-center flex-column cursor-pointer border-hovered`}
                                                                                style={{
                                                                                    border: selectedItems.some(selectedItem => selectedItem.category_id_ids === item.category_id_ids) ? '3px solid rgba(255, 154, 32, 1)' : '3px solid rgb(199, 212, 234)',
                                                                                    width: '145px',
                                                                                }}
                                                                                key={index}
                                                                                onClick={() => {
                                                                                    handleSelectItem(item)
                                                                                }}
                                                                            >
                                                                                <div style={{ height: '85px' }}>
                                                                                    <img src={item?.category_image_url_chr} style={{ width: '80px', height: '80px', objectFit: 'contain' }} alt="" />
                                                                                </div>

                                                                                <div className="mt-2 d-flex justify-content-center align-items-center fs-5 text-black text-center font-w600">
                                                                                    <span>{`${item?.category_display_name_chr == "Home Check-Up" ? "Home Inspector" : item?.category_display_name_chr}`}</span>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </> :
                                                                    <>
                                                                        <div className="d-flex justify-content-center align-items-center my-5 fs-5 text-black text-center font-w600">
                                                                            <span>{`No expertise found`}</span>
                                                                        </div>
                                                                    </>
                                                                }
                                                            </>}

                                                        </div>
                                                    </div>

                                                    <div className="row mx-0  my-2 ">
                                                        <div className="col-12 px-3 d-flex align-items-center p-2 fs-5 font-w600 text-danger" style={{ height: '30px' }}>
                                                            {isExpertiseErr && <>
                                                                <span style={{}}>
                                                                    <i class="bi bi-info-circle"></i>
                                                                </span>
                                                                <span className="ms-2">{`Please select at least one experience first`}</span>
                                                            </>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mx-0 mb-2">
                                                <div className="col-12 px-0 d-flex justify-content-center align-items-center">
                                                    <div className=" pe-2 font-w600 mt-2">
                                                        <PrimaryButton
                                                            onClick={(e) => { handleNewProDashboardSteps(3) }}
                                                            buttonName={"SKIP THIS STEP"}
                                                            style={{
                                                                width: "100%",
                                                                background: 'rgba(251, 252, 255, 1)',
                                                                border: '1px solid rgba(199, 212, 234, 1)',
                                                                color: "black",
                                                                boxshadow: '0px 6px 12px 0px rgba(102, 129, 172, 0.12)',
                                                                fontWeight: '600',
                                                            }}
                                                        />
                                                    </div>

                                                    <div className=" ps-2 font-w600 mt-2 d-flex justify-content-center">
                                                        <PrimaryButton
                                                            onClick={(e) => { handleSelectedExpertise() }}
                                                            buttonName={"NEXT"}
                                                            loadingMessage={"LOADING..."}
                                                            isLoading={false}
                                                            style={{
                                                                width: "150PX",
                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                border: '1px solid rgba(255, 154, 32, 1)',
                                                                fontWeight: '600',
                                                            }}
                                                        />
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </> :
                                newProDashboardSteps === 2 ?
                                    <>
                                        <div className="row mx-0">
                                            <div className="col-12 px-0">

                                                <div className="row mx-0 mt-4">
                                                    <div className="col-12 px-0 d-flex justify-content-center align-items-center">
                                                        <span className="fs-2 font-w600 text-black text-center my-2">{`Confirm your experience`}</span>
                                                    </div>
                                                </div>

                                                <div className="row mx-0 mb-2">
                                                    <div className="col-12 px-0 d-flex justify-content-center align-items-center">
                                                        <span className="fs-4 text-center my-2">{`Fill in your competency and experience to get more relevant jobs at Chilll`}</span>
                                                    </div>
                                                </div>

                                                <div className="row mx-0 w-100">
                                                    <div className="col-12 px-0">

                                                        <div className="row">
                                                            <div className="col-12 rounded-2 shadow-lg my-4 p-1" >
                                                                <div className="d-flex rounded-2" style={{ minHeight: '310px' }}>
                                                                    <div className=" d-flex flex-column overflow-auto rounded-start" style={{ width: '105px', background: 'rgba(235, 240, 250, 1)', }}>
                                                                        {selectedItems?.map((item, index) => {
                                                                            return (
                                                                                <div
                                                                                    className={`align-items-center border-3 border-bottom border-white d-flex justify-content-center p-2 ${item?.category_id_ids === individualExpertiseObj?.category_id_ids ? 'bg-white' : ''}`}
                                                                                >
                                                                                    <div>
                                                                                        <img src={item?.category_image_url_chr} style={{ width: '50px', height: '40px', objectFit: 'contain' }} alt="" />
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        })}

                                                                    </div>

                                                                    <div className="rounded-end w-100 h-100 p-3 bg-white">
                                                                        <div className="d-flex justify-content-between align-items-center mb-4">
                                                                            <div className="fs-4">
                                                                                <span className="text-black font-w600 ">Your experience in </span>
                                                                                <span className="font-w700 " style={{ color: 'orange' }}>{`${individualExpertiseObj?.category_display_name_chr}`}</span>
                                                                            </div>

                                                                            {/* <div
																								title={selectedItems.length === 1 ? 'At least one experience required' : ''}
																							>
																								<i
																									className="bi bi-trash3 fs-3 cursor-pointer text-hovered"
																									style={{
																										color: 'rgba(131, 154, 192, 1)',
																										pointerEvents: selectedItems.length === 1 ? 'none' : 'auto',
																										opacity: selectedItems.length === 1 ? '0.5' : '1'
																									}}
																								></i>
																							</div> */}
                                                                        </div>

                                                                        <div className='row mx-0 justify-content-between mt-3'>
                                                                            {saveExpertiseLoading ?
                                                                                <div className='col-12 mb-3'>
                                                                                    <SkeletonDivElement height={45} />
                                                                                </div> :

                                                                                <>

                                                                                    <div className='col-sm-6 px-0 pe-sm-2'>
                                                                                        <SelectInputCompetency
                                                                                            // labelName={txtExpertiseCompetency}
                                                                                            labelName={`Skill level`}
                                                                                            onChange={(e) => saveExpertiseCompetencyFn(e)}
                                                                                            defaultValue={saveExpertiseCompetency}
                                                                                            options={expertiseCompetencyArr}
                                                                                            errorOccured={isExpertiesCompetencyError}
                                                                                            errorMessage={"Please select competency"}
                                                                                            isRequired={true}
                                                                                        />
                                                                                    </div>

                                                                                    <div className='col-sm-6 px-0  ps-sm-2'>
                                                                                        <InputField
                                                                                            labelName={"Year of experience"}
                                                                                            placeholderName={"Year of experience"}
                                                                                            onChange={saveExpertiseExpFn}
                                                                                            onBlur={handleSaveExpertiseExpBlurCheck}
                                                                                            errorOccured={isExpertiesExpError}
                                                                                            errorMeesage={validTotalWorkExp}
                                                                                            value={`${saveExpertiseExp}`}
                                                                                            maxLength={2}
                                                                                            isRequired={true}
                                                                                        />
                                                                                    </div>
                                                                                </>}
                                                                        </div>

                                                                        <div className='mt-2 mx-0 row'>
                                                                            <div className='col-12 px-0'>
                                                                                <TextArea
                                                                                    labelName={`Bio`}
                                                                                    placeholder={`Bio`}
                                                                                    value={bioText}
                                                                                    onChange={handleBioText}
                                                                                    onBlur={() => { }}
                                                                                />
                                                                            </div>
                                                                        </div>


                                                                        <div className="">
                                                                            <div
                                                                                className="d-flex align-items-center"
                                                                            >
                                                                                <span
                                                                                    className="me-3"
                                                                                >
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={saveExpertiseCertificate}
                                                                                        className="form-check-input"
                                                                                        id="customCheckBox4"
                                                                                        onChange={(e) => {
                                                                                            setSaveExpertiseCertificate(e.target.checked)
                                                                                        }}
                                                                                        onClick={() => { setSaveExpertiseCertificate(!saveExpertiseCertificate) }}
                                                                                    />
                                                                                </span>
                                                                                <span
                                                                                    className="pt-1 cursor-pointer text-hovered font-w600 fs-6"
                                                                                    onClick={() => {
                                                                                        setSaveExpertiseCertificate(!saveExpertiseCertificate)
                                                                                    }}
                                                                                >
                                                                                    {`I’m a certified expert`}
                                                                                </span>
                                                                            </div>
                                                                        </div>

                                                                        {/* <div className="d-flex justify-content-end">
                                                                            <PrimaryButton
                                                                                onClick={(e) => { handleSaveExpertise() }}
                                                                                buttonName={"SAVE"}
                                                                                loadingMessage={"LOADING..."}
                                                                                isLoading={saveExpertiseLoading}
                                                                                style={{
                                                                                    width: "150px",
                                                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                    border: '1px solid rgba(255, 154, 32, 1)',
                                                                                    fontWeight: '600',
                                                                                    pointerEvents: individualExpertiseCounter == selectedItems.length ? 'none' : 'auto',
                                                                                    opacity: individualExpertiseCounter == selectedItems.length ? '0.5' : '1'
                                                                                }}
                                                                            />
                                                                        </div> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>




                                                <div className="row mx-0 mb-2">
                                                    <div className="col-12 px-0 d-flex justify-content-center align-items-center">
                                                        <div className=" pe-2 font-w600 mt-2">
                                                            <PrimaryButton
                                                                onClick={(e) => { handleNewProDashboardSteps(3) }}
                                                                buttonName={"SKIP THIS STEP"}
                                                                style={{
                                                                    width: "100%",
                                                                    background: 'rgba(251, 252, 255, 1)',
                                                                    border: '1px solid rgba(199, 212, 234, 1)',
                                                                    color: "black",
                                                                    boxshadow: '0px 6px 12px 0px rgba(102, 129, 172, 0.12)',
                                                                    fontWeight: '600',
                                                                }}
                                                            />
                                                        </div>

                                                        <div className=" ps-2 font-w600 mt-2 d-flex justify-content-center">
                                                            <PrimaryButton
                                                                onClick={(e) => { handleSaveExpertise() }}
                                                                buttonName={"NEXT"}
                                                                loadingMessage={"SAVING..."}
                                                                isLoading={saveExpertiseLoading}
                                                                style={{
                                                                    width: "150px",
                                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                    border: '1px solid rgba(255, 154, 32, 1)',
                                                                    fontWeight: '600',
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </> :
                                    newProDashboardSteps === 3 ?
                                        <>
                                            <div className="row mx-0">
                                                <div className="col-12 px-0">

                                                    <div className="row mx-0 mt-4">
                                                        <div className="col-12 px-0 d-flex justify-content-center align-items-center">
                                                            <span className="fs-2 font-w600 text-black text-center my-2">{`Add your documents`}</span>
                                                        </div>
                                                    </div>

                                                    <div className="row mx-0 mb-2">
                                                        <div className="col-12 px-0 d-flex justify-content-center align-items-center">
                                                            <span className="fs-4 text-center my-2">{`Upload your credentials so that Chilll can verify them. Use a .pdf, .jpg or .png file. Max size: 20 MB`}</span>
                                                        </div>
                                                    </div>


                                                    <div className="row">
                                                        <div className="col-12 px-0 d-flex justify-content-center align-items-center flex-column">

                                                            <div className="row">
                                                                <div className="col-12 d-flex flex-wrap justify-content-center  py-3">

                                                                    <div
                                                                        className={`shadow rounded-2 p-4 m-1 d-flex  align-items-center flex-column cursor-pointer border-hovered`}
                                                                        style={{
                                                                            border: '2px solid rgb(199, 212, 234)',
                                                                            width: '150px',
                                                                        }}
                                                                        onClick={() => {
                                                                            handleOpenDocumentsModal()
                                                                            setDocumentTypeInt(1);
                                                                            setDocumentTypeName('an identity');
                                                                            setToggleForDocuments(2);
                                                                        }}
                                                                    >
                                                                        <div style={{ height: '100px' }}>
                                                                            <img src={proLicense} style={{ height: '80px', width: '100px', objectFit: 'contain' }} alt="" />
                                                                        </div>

                                                                        <div>
                                                                            <div className=" d-flex justify-content-center align-items-center fs-5 text-black text-center font-w700">
                                                                                <span>{`Identity`}</span>
                                                                            </div>

                                                                            <div className="mt-1 d-flex justify-content-center align-items-center fs-7 text-center font-w500">
                                                                                <span>{`Drivers license, passport, identity card`}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div
                                                                        className={`shadow rounded-2 p-4 m-1 d-flex  align-items-center flex-column cursor-pointer border-hovered`}
                                                                        style={{
                                                                            border: '2px solid rgb(199, 212, 234)',
                                                                            width: '150px',
                                                                        }}
                                                                        onClick={() => {
                                                                            handleOpenDocumentsModal()
                                                                            setDocumentTypeInt(2);
                                                                            setDocumentTypeName('certificate');
                                                                            setToggleForDocuments(2);
                                                                        }}
                                                                    >
                                                                        <div div style={{ height: '100px' }}>
                                                                            <img src={proCerificate} style={{ height: '80px', width: '100px', objectFit: 'contain' }} alt="" />
                                                                        </div>

                                                                        <div>
                                                                            <div className=" d-flex justify-content-center align-items-center fs-5 text-black text-center font-w700">
                                                                                <span>{`Certifications`}</span>
                                                                            </div>

                                                                            <div className="mt-1 d-flex justify-content-center align-items-center fs-7 text-center font-w500">
                                                                                <span>{`School transcripts, skill certifications`}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div
                                                                        className={`shadow rounded-2 p-4 m-1 d-flex align-items-center flex-column cursor-pointer border-hovered`}
                                                                        style={{
                                                                            border: '2px solid rgb(199, 212, 234)',
                                                                            width: '150px',
                                                                        }}
                                                                        onClick={() => {
                                                                            handleOpenDocumentsModal()
                                                                            setDocumentTypeInt(4);
                                                                            setDocumentTypeName('insurance');
                                                                            setToggleForDocuments(2);
                                                                        }}
                                                                    >
                                                                        <div div style={{ height: '100px' }}>
                                                                            <img src={proInsurance} style={{ height: '80px', width: '100px', objectFit: 'contain' }} alt="" />
                                                                        </div>

                                                                        <div>
                                                                            <div className=" d-flex justify-content-center align-items-center fs-5 text-black text-center font-w700">
                                                                                <span>{`Insurance`}</span>
                                                                            </div>

                                                                            <div className="mt-1 d-flex justify-content-center align-items-center fs-7 text-center font-w500">
                                                                                <span>{`Insurance, bonds`}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mx-0 mb-2 ">

                                                        {proDocumentsArr?.map((item, index) => {
                                                            return (
                                                                <>
                                                                    <div className="col-sm-6 p-1" key={index}>
                                                                        <div
                                                                            className="rounded-2 p-3 d-flex h-100"
                                                                            style={{
                                                                                border: '2px solid rgb(199, 212, 234)',
                                                                                background: 'rgb(199 212 234 / 48%)',
                                                                            }}
                                                                        >
                                                                            <div
                                                                                className="align-items-center bg-grey border-hovered border border-2 border-white d-flex justify-content-center me-3 rounded-2"
                                                                                style={{
                                                                                    width: '90px',
                                                                                    height: '80px',
                                                                                }}
                                                                                onClick={() => {
                                                                                    handleOpenDoc(); setImageAttachURL(item?.document_url_chr);
                                                                                }}
                                                                            >
                                                                                <img
                                                                                    src={item?.document_url_chr}
                                                                                    className="w-100 h-100 cursor-pointer  rounded-2"
                                                                                    style={{ objectFit: 'contain' }}
                                                                                    alt=""
                                                                                />
                                                                            </div>

                                                                            <div className="d-flex justify-content-between w-100">
                                                                                <div className="d-flex flex-column w-100">
                                                                                    <div className="fs-6 d-flex align-items-center">
                                                                                        <span>
                                                                                            <i className="bi bi-patch-check pe-2"></i>
                                                                                        </span>
                                                                                        <span>{`Not verified`}</span>
                                                                                    </div>

                                                                                    <div className="mt-1 fs-4 font-w600 text-black">
                                                                                        <span>
                                                                                            {item?.document_type_int == 1 ? "Identity" :
                                                                                                item?.document_type_int == 2 ? "Certificate" :
                                                                                                    item?.document_type_int == 3 ? "Address" :
                                                                                                        item?.document_type_int == 4 ? "Insurance" : "Other"}
                                                                                        </span>
                                                                                    </div>

                                                                                    <div className="mt-1 fs-6 ">
                                                                                        {item?.note_chr ? <span>{item?.note_chr}</span> : ''}
                                                                                    </div>
                                                                                </div>

                                                                                <div>
                                                                                    <OverlayTrigger
                                                                                        key={index}
                                                                                        trigger="click"
                                                                                        placement="bottom"
                                                                                        overlay={popoverDocument(index)}
                                                                                        rootClose={true}
                                                                                        show={activePopover === index}
                                                                                        onToggle={(show) => setActivePopover(show ? index : null)}
                                                                                    >
                                                                                        <span onClick={() => handleMenuClick(item, index)} className="d-flex align-items-center justify-content-center rounded-circle overlay-action-btn cursor-pointer ms-2 " style={{ height: '25px', width: '25px' }}>
                                                                                            <i className="bi bi-three-dots-vertical fs-4 text-black "></i>
                                                                                        </span>
                                                                                    </OverlayTrigger>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )
                                                        })}


                                                    </div>

                                                    <div className="row mx-0 mb-2">
                                                        <div className="col-12 px-0 d-flex justify-content-center align-items-center">
                                                            <div className=" pe-2 font-w600 mt-2">
                                                                <PrimaryButton
                                                                    onClick={(e) => { handleNewProDashboardSteps(4) }}
                                                                    buttonName={"SKIP THIS STEP"}
                                                                    style={{
                                                                        width: "100%",
                                                                        background: 'rgba(251, 252, 255, 1)',
                                                                        border: '1px solid rgba(199, 212, 234, 1)',
                                                                        color: "black",
                                                                        boxshadow: '0px 6px 12px 0px rgba(102, 129, 172, 0.12)',
                                                                        fontWeight: '600',
                                                                    }}
                                                                />
                                                            </div>

                                                            <div className=" ps-2 font-w600 mt-2 d-flex justify-content-center">
                                                                <PrimaryButton
                                                                    onClick={(e) => { handleNewProDashboardSteps(4) }}
                                                                    buttonName={"NEXT"}
                                                                    loadingMessage={"LOADING..."}
                                                                    isLoading={false}
                                                                    style={{
                                                                        width: "150px",
                                                                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                        border: '1px solid rgba(255, 154, 32, 1)',
                                                                        fontWeight: '600',
                                                                    }}
                                                                />
                                                            </div>


                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </> :
                                        newProDashboardSteps === 4 ?
                                            <>
                                                <div className="row mx-0">
                                                    <div className="col-12 px-0">

                                                        <div className="row mx-0 mt-4">
                                                            <div className="col-12 px-0 d-flex justify-content-center align-items-center">
                                                                <span className="fs-2 font-w600 text-black text-center my-2">{`You're almost there!`}</span>
                                                            </div>
                                                        </div>

                                                        <div className="row mx-0 mb-2">
                                                            <div className="col-12 px-0 d-flex justify-content-center align-items-center">
                                                                <span className="fs-4 text-center my-2">{`Just watch our short video guide to get familiar with the best features of the Chilll web app. All tutorials are available to you at any time in the Tips & Tricks section.`}</span>
                                                            </div>
                                                        </div>


                                                        <div className="row">
                                                            <div className="col-12 px-0 d-flex justify-content-center align-items-center flex-column">
                                                                <div className="row">
                                                                    <div className="col-12 d-flex justify-content-center align-items-center py-3">
                                                                        {isLoadingImg &&
                                                                            <div className=' d-flex justify-content-center align-items-center' style={{ height: '300px' }}>
                                                                                <Spinner animation="border" size="lg" style={{}} />
                                                                            </div>
                                                                        }
                                                                        <img
                                                                            src={videoImg}
                                                                            style={{
                                                                                maxWidth: '100%',
                                                                                maxHeight: '300px',
                                                                                display: isLoadingImg ? 'none' : 'block'
                                                                            }}
                                                                            alt=""
                                                                            onLoad={handleImageLoaded}
                                                                            onError={handleImageError}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row mx-0 mb-2">
                                                            <div className="col-12 px-0 d-flex justify-content-center align-items-center">

                                                                <div className=" ps-2 font-w600 mt-2 d-flex justify-content-center">
                                                                    <PrimaryButton
                                                                        onClick={(e) => {
                                                                            dispatch(setProOnboardingFlag());
                                                                            dispatch(setIsSignUpFlagFalse());
                                                                            navigate('/dashboard');
                                                                        }}
                                                                        buttonName={"GO TO MY DASHBOARD"}
                                                                        loadingMessage={"LOADING..."}
                                                                        isLoading={false}
                                                                        style={{
                                                                            width: "250px",
                                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                            border: '1px solid rgba(255, 154, 32, 1)',
                                                                            fontWeight: '600',
                                                                        }}
                                                                    />
                                                                </div>


                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </> : <></>
                            }
                        </div>
                    </div>

                </div>
            </div>

            {/* New Modal for add/edit document */}
            <Modal className='fade' centered show={documentsModalTrigger}>
                <Modal.Body>
                    <div className='row mx-0'>
                        <div className='col-12 px-0'>
                            <>
                                <div className='row mx-0'>
                                    <div className='col-6 px-0 d-flex justify-content-start align-items-center'>
                                        {/* {toggleForDocuments === 2 && !documentId &&
											<div
												className='cursor-pointer d-flex align-items-center text-hovered font-w600 fs-5'
												onClick={() => handleClearDocStates()}
											>
												<span>
													<i className='bi bi-arrow-left me-2'></i>
												</span>
												<span>
													Back
												</span>
											</div>
										} */}
                                    </div>

                                    <div className='col-6 px-0 d-flex justify-content-end'>
                                        <span onClick={() => handleCloseDocumentsModal()} className='cursor-pointer fs-4 text-black text-hovered'>
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>
                                <div className='mx-0 row text-black mb-2'>
                                    <div className='col-12 font-w600 fs-3 px-0 text-center'>
                                        <span>
                                            <>{documentId ? `Edit ${documentTypeName}` : `Add ${documentTypeName} document`}</>
                                        </span>
                                    </div>
                                </div>

                                {
                                    <div className='mx-0 row  mb-2'>
                                        <div className='col-12 font-w500 fs-5 px-0 text-center font-w500'>
                                            <span>
                                                {"Upload .pdf, .jpg or .png file. Max size: 20 MB"}
                                            </span>
                                        </div>
                                    </div>
                                }


                                {toggleForDocuments === 2 &&
                                    <>
                                        <div className='mx-0 row my-4'>
                                            <div className='col-12 px-0 d-flex justify-content-center'>
                                                <input ref={uploadDocRef} onChange={(e) => { handleUploadDoc(e) }} className="form-control" type="file" accept="image/*, application/pdf, application/vnd.ms-excel" hidden />
                                                {uploadDoc ?
                                                    <>
                                                        <div className='d-flex flex-column w-100'>
                                                            <div
                                                                className='align-items-center rounded-2 d-flex flex-column font-w500 fs-4 justify-content-center w-100 position-relative'
                                                                style={{
                                                                    height: "200px",
                                                                    background: 'rgba(244, 248, 255, 1)',
                                                                    color: 'rgba(131, 154, 192, 1)',
                                                                    border: '2px solid rgb(199, 212, 234)',
                                                                }}
                                                            >
                                                                <i className="bi bi-x-circle cursor-pointer end-0 me-2 mt-1 position-absolute top-0 fs-3" onClick={(e) => { e.stopPropagation(); deleteUploadDoc() }}></i>
                                                                {uploadDocImgPre && <img onClick={() => { handleOpenDoc(); setImageAttachURL(uploadDocImgPre); }} src={uploadDocImgPre} className='h-100 border cursor-pointer' alt="Document" />}

                                                                {/* {pdfFile && (
                                                                    <div>
                                                                        <Document
                                                                            file={pdfFile}
                                                                            onLoadSuccess={onDocumentLoadSuccess}
                                                                        >
                                                                            {Array.from(new Array(numPages), (el, index) => (
                                                                                <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                                                                            ))}
                                                                        </Document>
                                                                    </div>
                                                                )} */}

                                                            </div>
                                                            {/* <div className='text-center'>
                                                                <span>{uploadDoc.name}</span>
                                                            </div> */}
                                                        </div>
                                                    </> :
                                                    <div
                                                        onClick={handleClickUploadDoc}
                                                        className='align-items-center rounded-2  cursor-pointer d-flex flex-column font-w600 fs-3 justify-content-center w-100'
                                                        style={{
                                                            height: "200px",
                                                            background: 'rgba(244, 248, 255, 1)',
                                                            color: 'rgba(131, 154, 192, 1)',
                                                            border: '2px solid rgb(199, 212, 234)',
                                                        }}
                                                    >
                                                        <span>
                                                            <i className="bi bi-upload"></i>
                                                        </span>
                                                        <span>
                                                            {"Upload file"}
                                                        </span>
                                                    </div>
                                                }
                                            </div>
                                        </div>

                                        <div className='row mx-0 mt-3'>
                                            <div className='col-12 px-0'>
                                                <InputField
                                                    labelName={"Note"}
                                                    placeholderName={"Note"}
                                                    onChange={handleDocumentNotes}
                                                    onBlur={() => { }}
                                                    errorOccured={``}
                                                    errorMeesage={``}
                                                    value={`${documentNotes}`}
                                                />
                                            </div>
                                        </div>



                                        {documentTypeInt === 5 &&
                                            <div className='row mx-0 justify-content-between mt-3'>
                                                <div className='col-md-6 px-0 pe-md-2'>
                                                    <SelectInputCountry
                                                        labelName={'Country'}
                                                        onChange={(e) => handleDocumentCountryName(e)}
                                                        defaultValue={documentCountryName}
                                                        options={countryCodeArr}
                                                    />
                                                </div>

                                                <div className='col-md-6 px-0  ps-md-2'>
                                                    <SelectInputState
                                                        labelName={'State'}
                                                        defaultValue={documentStateName}
                                                        onChange={(e) => handleDocumentStateName(e)}
                                                        options={stateArr}
                                                    />
                                                </div>
                                            </div>
                                        }

                                        {fileSizeLimitErr &&
                                            <div className='my-1'>
                                                <span className='text-danger fs-6 font-w600'>{`File size should not exceed 20 MB`}</span>
                                            </div>
                                        }

                                        {isDocumentErr &&
                                            <div className='my-1'>
                                                <span className='text-danger fs-6 font-w600'>{`Please select file to uplaod your document`}</span>
                                            </div>
                                        }

                                        <div className='row mx-0 mt-3'>
                                            <div className='col-12 px-0'>
                                                <PrimaryButton
                                                    onClick={() => {
                                                        uploadProfessionalDocumentFn()
                                                    }}
                                                    buttonName={"SUBMIT"}
                                                    type="submit"
                                                    loadingMessage="SAVING..."
                                                    isLoading={updateDocumentsLoading}
                                                    style={{
                                                        width: '100%',
                                                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                        border: '2px solid rgba(255, 154, 32, 1)',
                                                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </>
                                }
                            </>
                        </div>
                    </div>
                </Modal.Body>
            </Modal >

            {/* Modal for previewing the attached image preview */}
            <>
                <Modal show={openDoc} onHide={handleCloseDoc} centered style={{ background: '#fff0', border: 'none', }}>

                    <div className='image-preview-modal-header'>

                        <a href={imageAttachURL} target="_blank" rel="noreferrer">
                            <i style={{ fontSize: '20px', marginLeft: '20px' }} className="bi bi-download image-preview-modal-action-btn" />
                        </a>

                        <div onClick={handleCloseDoc} className='image-preview-modal-action-btn-close'>
                            <i style={{ fontSize: '30px', }} className="bi bi-x"></i>
                        </div>

                    </div>

                    <>
                        <img src={imageAttachURL} alt='document' style={{ width: '100%', height: '100%' }} />
                    </>

                </Modal>
            </>

            {/* Modal for delete document */}
            <Modal className='fade' centered show={deleteDocumentModalTrigger}>
                <Modal.Body>
                    <div className='row mx-0'>
                        <div className='col-12 px-0'>
                            <>
                                <div className='mx-0 row text-black mb-4'>
                                    <div className='col-11 font-w600 fs-3 px-0 text-center'>
                                        <span>
                                            {"Delete document"}
                                        </span>
                                    </div>
                                    <div className='col-1 d-flex fs-4 justify-content-end px-0'>
                                        <span onClick={() => handleCloseDeleteDocumentModal()} className='cursor-pointer fs-4 text-black text-hovered'>
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                <div className='mx-0 row mb-4'>
                                    <div className='col-12 font-w500 fs-5 px-0 text-center'>
                                        <span>
                                            {`Are you sure you want to delete this ${documentObject?.document_type_int == 1 ? "identity" :
                                                documentObject?.document_type_int == 2 ? "certificate" :
                                                    documentObject?.document_type_int == 3 ? "address" :
                                                        documentObject?.document_type_int == 4 ? "insurance" : "other"} document?`}
                                        </span>
                                    </div>

                                </div>



                                <div className='row mx-0 mt-2'>
                                    <div className='col-12 px-0'>
                                        <PrimaryButton
                                            onClick={() => {
                                                // uploadProfessionalDocuments()
                                                delelteDocumentByIdFn()
                                            }}
                                            buttonName={"DELETE"}
                                            type="submit"
                                            loadingMessage="DELETING..."
                                            isLoading={updateDocumentsLoading}
                                            style={{
                                                width: "100%",
                                                background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                                                boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                                                border: '1px solid rgba(240, 72, 72, 1)',
                                            }}
                                        />
                                    </div>
                                </div>
                            </>

                        </div>
                    </div>
                </Modal.Body>
            </Modal >

            {/* Modal for the Use Chilll As*/}
            <Modal className='fade' centered show={useChilllModalTrigger}>
                <Modal.Body>
                    <div className='row mx-0'>
                        <div className='col-12 px-0'>
                            <>
                                <div className='mx-0 row text-black mb-4'>
                                    <div className='col-11 font-w600 fs-3 px-0 text-center'>
                                        <span>
                                            {"Use Chilll to"}
                                        </span>
                                    </div>
                                    <div className='col-1 d-flex fs-4 justify-content-end px-0'>
                                        {/* <span onClick={() => handleCloseUseChilllModal()} className='cursor-pointer fs-4 text-black text-hovered'>
                                            <i className="bi bi-x-lg"></i>
                                        </span> */}
                                    </div>
                                </div>

                                {/* <div className='mx-0 row mb-4'>
                                    <div className='col-12 font-w500 fs-5 px-0 text-center'>
                                        <span>
                                            {`Do you `}
                                        </span>
                                    </div>
                                </div> */}

                                <div className='row mb-4'>
                                    <div className='col-12 px-0'>
                                        {serviceRequestOptions?.map((ele, index) => {
                                            return (
                                                <div key={index} className='mx-0 row lh-lg cursor-pointer overlay-action-btn text-black' onClick={() => { handleServiceRequestoption(ele) }}>
                                                    <div className='col-12 font-w500 fs-4 px-0'>
                                                        <div className={`${index !== (serviceRequestOptions.length - 1) && "border-bottom"} mx-0 p-2 row `}>
                                                            <div className="align-items-cente col-2 d-flex px-0 justify-content-center">
                                                                <input
                                                                    className="form-check-input d-flex"
                                                                    type="radio"
                                                                    name="avatar"
                                                                    value={ele.option_id_ids}
                                                                    onChange={(e) => setServiceReqOptionId(ele.option_id_ids)}
                                                                    checked={ele.option_id_ids === serviceReqOptionId}
                                                                />
                                                            </div>

                                                            <div className={`align-items-cente col-10 d-flex px-0 ${ele.option_id_ids === serviceReqOptionId ? "font-w600" : "font-w500"}`}>
                                                                <span>
                                                                    {ele.option_value_chr}
                                                                </span>
                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>
                                            )
                                        })}

                                        {serviceReqOptionErr &&
                                            <span className='text-danger'>{`Please select option`}</span>
                                        }
                                    </div>
                                </div>



                                <div className='row mx-0 mt-2'>
                                    <div className='col-12 px-0'>
                                        <PrimaryButton
                                            onClick={() => {
                                                // uploadProfessionalDocuments()
                                                handleSubmitServiceReqOption()
                                            }}
                                            buttonName={"SUBMIT"}
                                            type="submit"
                                            loadingMessage="SUBMITTING..."
                                            isLoading={serviceReqOptionLoading}
                                            style={{
                                                width: "100%",
                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                border: '1px solid rgba(255, 154, 32, 1)',
                                                fontWeight: '600',
                                            }}
                                        />
                                    </div>
                                </div>
                            </>

                        </div>
                    </div>
                </Modal.Body>
            </Modal >

            <Modal
                className="fade"
                show={isSignUpFlag && proOnboardingModalTrigger && isFreeTrialSubscription && subscriptionTimeLeft}
                // onHide={handleClose}
                centered
            >
                <Modal.Body>
                    <div className="row mx-0">
                        <div className="col-12 px-0">
                            <div className="row mx-0">
                                <div className="col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black">
                                    <span
                                        onClick={() => { setProOnboardingModalTrigger(false) }}
                                        className="cursor-pointer">
                                        <i className="bi bi-x-lg"></i>
                                    </span>
                                </div>
                            </div>

                            <div className="row mx-0 mb-3">
                                <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                    <i className='bi bi-check2-circle text-success' style={{ fontSize: '100px' }} />
                                </div>
                            </div>

                            <div className="row mx-0 mb-3">
                                <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                    <span className="text-center">{'Congratulations!'}</span>
                                </div>
                            </div>

                            <div className="row mx-0 mt-3 pb-2">
                                <div className="col-12 px-0 d-flex justify-content-center align-items-center">
                                    {/* <span className="fs-5 text-center">
                                                    {"Measuring feature is avaible on mobile devices. Please download Chilll app from playstore or appstore to use this feature."}
                                                </span> */}

                                    <p className="fs-4 text-center font-w600">
                                        Welcome aboard! You have received <span className="font-w600 text-black">{`${subscriptionTimeLeft}`} days </span> free trial to use in Chilll services.
                                    </p>
                                </div>
                            </div>

                            <div className="row mx-0 text-black mt-2">
                                <div className="col-12 font-w600 mb-2 d-flex justify-content-center">
                                    <PrimaryButton
                                        onClick={() => { setProOnboardingModalTrigger(false) }}
                                        buttonName={"AWESOME"}
                                        style={{
                                            width: "auto",
                                            border: 'none',
                                            background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                            boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                            fontWeight: '600',
                                        }}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal.Body>
            </Modal>


            {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />}

            {handleToasterNew && <ResponceToaster toasterType={'info'} message={'Please select expertise first'} />}

        </>
    )
}

export default NewProDashboard;